export default "__VITE_ASSET__B5L5rRUd__"